import React from 'react';
import styled from 'styled-components';
import { Body1, Container } from '@ui';
import { logNetRequest } from '@utils/usefulFuncs';
import { handle400Statuses, sendApiRequest } from '@services/api';
import { FILTERED_DOCUMENT_SELECTION_FILTERS, FilteredDocumentsSelection } from './FilteredDocumentsSelection';
import { FilterableDocumentsContextProvider } from '@/contexts/FilterableDocumentsContext';

const Wrapper = styled.div``;

export const UploadedDocumentsSelection = ({ singleDocMode = false }) => {
  const [initializing, setInitializing] = React.useState(true);
  const [error, setError] = React.useState(null);

  const docGetter = async () => {
    const URL = 'v1/genai/documents?category=user';
    const { status, data, error } = await sendApiRequest('get', URL);
    handle400Statuses(status);
    logNetRequest(status, data, error);
    setInitializing(false);

    if (status !== 200) {
      setError('Error fetching documents, please refresh and try again.');
      return null;
    }
    return data?.documents || null;
  };

  if (error) {
    return (
      <Wrapper>
        <Container centerAll top={72} bottom={96}>
          <Body1>{error}</Body1>
        </Container>
      </Wrapper>
    );
  }

  return (
    <FilterableDocumentsContextProvider docGetter={docGetter}>
      <FilteredDocumentsSelection
        singleDocMode={singleDocMode}
        initializing={initializing}
        filterModes={[
          FILTERED_DOCUMENT_SELECTION_FILTERS.documentTypes,
          FILTERED_DOCUMENT_SELECTION_FILTERS.reportingPeriods,
        ]}
      />
    </FilterableDocumentsContextProvider>
  );
};
